module.exports = __webpack_public_path__ + "img/imp.12ec656e.png";